(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const locale = document.documentElement.lang || 'pl-PL';
    const businessTimeZone = 'Europe/Warsaw';
    const warsawWeekday = new Intl.DateTimeFormat('en-US', { timeZone: businessTimeZone, weekday: 'short' });

    function warsawToday() {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: businessTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      return { year: Number(values.year), month: Number(values.month), day: Number(values.day) };
    }

    function addDaysIso(base, days) {
      const date = new Date(Date.UTC(base.year, base.month - 1, base.day + days, 12));
      return date.toISOString().slice(0, 10);
    }

    function isSunday(iso) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
      return warsawWeekday.format(new Date(iso + 'T12:00:00Z')) === 'Sun';
    }

    function nextNonSunday(iso) {
      let date = new Date(iso + 'T12:00:00Z');
      while (isSunday(date.toISOString().slice(0, 10))) {
        date.setUTCDate(date.getUTCDate() + 1);
      }
      return date.toISOString().slice(0, 10);
    }

    function formatDate(iso, options) {
      const text = new Intl.DateTimeFormat(locale, { timeZone: businessTimeZone, ...options })
        .format(new Date(iso + 'T12:00:00Z'));
      return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
    }

    function parseOccupancy(raw, automatic = false) {
      try {
        const counts = JSON.parse(raw);
        if (!counts || Array.isArray(counts) || typeof counts !== 'object') return null;
        if (automatic) {
          const timestamp = counts._reconciled_at;
          if (typeof timestamp !== 'string' ||
              !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(timestamp)) return null;
          const age = Date.now() - Date.parse(timestamp);
          if (!Number.isFinite(age) || age < 0 || age >= 30 * 60 * 1000) return null;
        }
        for (const [date, slots] of Object.entries(counts)) {
          if (date === '_reconciled_at' && automatic) continue;
          if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !slots || Array.isArray(slots) || typeof slots !== 'object') return null;
          for (const count of Object.values(slots)) {
            if (!Number.isSafeInteger(count) || count < 0) return null;
          }
        }
        return counts;
      } catch (_) {
        return null;
      }
    }

    function isSlotFull(counts, date, slot) {
      // No delivery windows are available on 5 November 2026.
      if (date === '2026-11-05') return true;
      // One-off merchant blackout: these morning windows reopen automatically
      // after 31 October without changing Shopify Flow occupancy data.
      if ((date === '2026-10-30' || date === '2026-10-31') && slot === '10:00–12:00') return true;
      if (!counts) return false;
      const limit = date === '2026-10-19' ? 2 : 5;
      return (counts[date]?.[slot] || 0) >= limit;
    }

    function clearOccupiedSlotCartAttribute(form) {
      if (window.louCapacitySlotClearPromise) return window.louCapacitySlotClearPromise;
      const pending = fetch(form.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Przedział dostawy': '' } }),
      }).then((response) => {
        if (!response.ok) throw new Error('Could not clear a fully booked delivery window');
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        if (window.louCapacitySlotClearPromise === pending) window.louCapacitySlotClearPromise = null;
      });
      window.louCapacitySlotClearPromise = pending;
      return pending;
    }

    function updateSlotCapacity(form) {
      const automatic = form.dataset.deliveryAutomatic === 'true';
      const counts = parseOccupancy(form.dataset.deliveryOccupancy, automatic);
      const date = form.querySelector('[data-delivery-date]')?.value;
      const slotField = form.querySelector('[data-delivery-field="slot"]');
      form.dataset.capacityInvalid = counts ? 'false' : 'true';
      if (automatic) {
        const unavailable = !counts;
        form.querySelector('[data-delivery-date]').disabled = unavailable;
        const maximum = form.dataset.maximumDate;
        const tomorrow = form.querySelector('[data-date-tomorrow]');
        const dayAfter = form.querySelector('[data-date-day-after]');
        tomorrow.disabled = unavailable || tomorrow.value > maximum;
        dayAfter.disabled = unavailable || dayAfter.value > maximum;
        form.querySelector('[data-date-custom]').disabled = unavailable;
        if (unavailable) {
          const calendar = form.querySelector('[data-delivery-calendar]');
          calendar.hidden = true;
          form.querySelector('[data-date-custom]').setAttribute('aria-expanded', 'false');
        }
        const configError = slotField.querySelector('[data-delivery-config-error]');
        if (configError) configError.hidden = !unavailable;
        if (form.louCapacityExpiryTimer) window.clearTimeout(form.louCapacityExpiryTimer);
        if (counts) {
          const remaining = 30 * 60 * 1000 - (Date.now() - Date.parse(counts._reconciled_at));
          form.louCapacityExpiryTimer = window.setTimeout(() => updateSlotCapacity(form), Math.max(1, remaining + 1));
        }
      }
      slotField.querySelectorAll('input[name="attributes[Przedział dostawy]"]').forEach((input) => {
        const full = Boolean(date && isSlotFull(counts, date, input.value));
        if (full && input.checked) {
          input.checked = false;
          form.dataset.fullSlotCleared = 'true';
          clearOccupiedSlotCartAttribute(form);
        }
        input.disabled = !counts || full;
        input.setAttribute('aria-disabled', input.disabled ? 'true' : 'false');
        input.closest('label')?.setAttribute('aria-disabled', input.disabled ? 'true' : 'false');
        const unavailable = input.closest('label')?.querySelector('[data-slot-unavailable]');
        if (unavailable) unavailable.hidden = !full;
      });
      if (counts && !date) form.dataset.fullSlotCleared = 'false';
      return Boolean(counts);
    }

    async function refreshSlotCapacity(scope) {
      const form = scope.querySelector('[data-cart-delivery-form]');
      const sectionId = form?.closest('.shopify-section')?.id.replace('shopify-section-', '');
      if (!form) throw new Error('Delivery form was not found');
      if (!sectionId) {
        form.dataset.deliveryOccupancy = '';
        updateSlotCapacity(form);
        return;
      }
      const url = form.dataset.cartUrl + '?section_id=' + encodeURIComponent(sectionId) + '&capacity_check=' + Date.now();
      try {
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error('Could not refresh delivery capacity');
        const html = await response.text();
        const current = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-delivery-form]');
        if (!current) throw new Error('Delivery configuration was not found');
        form.dataset.deliveryOccupancy = current.dataset.deliveryOccupancy || '';
        form.dataset.deliveryAutomatic = current.dataset.deliveryAutomatic || '';
      } catch (error) {
        console.error(error);
        form.dataset.deliveryOccupancy = '';
      }
      updateSlotCapacity(form);
    }

    function setInvalid(field, invalid, reason) {
      const error = field.querySelector('[data-delivery-error]');
      const sundayError = field.querySelector('[data-delivery-sunday-error]');
      const capacityError = field.querySelector('[data-delivery-capacity-error]');
      const configError = field.querySelector('[data-delivery-config-error]');
      field.dataset.invalid = invalid ? 'true' : 'false';
      if (error) error.hidden = !invalid || Boolean(reason);
      if (sundayError) sundayError.hidden = !invalid || reason !== 'sunday';
      if (capacityError) capacityError.hidden = !invalid || reason !== 'full';
      if (configError) configError.hidden = !invalid || reason !== 'config';
      field.querySelectorAll('input, textarea').forEach((input) => {
        if (invalid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      });
    }

    function clearSundayCartAttribute(form) {
      if (window.louSundayDateClearPromise) return window.louSundayDateClearPromise;
      const pending = fetch(form.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Data dostawy': '' } }),
      }).then((response) => {
        if (!response.ok) throw new Error('Could not clear Sunday delivery date');
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        if (window.louSundayDateClearPromise === pending) window.louSundayDateClearPromise = null;
      });
      window.louSundayDateClearPromise = pending;
      return pending;
    }

    function initDeliveryForm(form) {
      if (form.dataset.deliveryInitialized) return;
      form.dataset.deliveryInitialized = 'true';
      const checkoutForm = form.closest('[data-cart-checkout-form]');
      if (checkoutForm) checkoutForm.noValidate = true;

      const dateInput = form.querySelector('[data-delivery-date]');
      const dateShortcuts = form.querySelector('[data-delivery-date-shortcuts]');
      const tomorrowInput = form.querySelector('[data-date-tomorrow]');
      const dayAfterInput = form.querySelector('[data-date-day-after]');
      const customButton = form.querySelector('[data-date-custom]');
      const calendar = form.querySelector('[data-delivery-calendar]');
      const calendarHeading = form.querySelector('[data-calendar-heading]');
      const calendarWeekdays = form.querySelector('[data-calendar-weekdays]');
      const calendarDays = form.querySelector('[data-calendar-days]');
      const previousMonth = form.querySelector('[data-calendar-previous]');
      const nextMonth = form.querySelector('[data-calendar-next]');
      const dateSummary = form.querySelector('[data-delivery-date-summary]');
      const dateSummaryValue = form.querySelector('[data-delivery-date-summary-value]');
      const today = warsawToday();
      const sameDay = form.dataset.sameDay === 'true';
      const horizon = Math.max(1, Number(form.dataset.bookingHorizon) || 30);
      const firstOffset = sameDay ? 0 : 1;
      const minimum = addDaysIso(today, firstOffset);
      const maximum = addDaysIso(today, horizon);
      const nominalTomorrow = addDaysIso(today, 1);
      const nominalDayAfter = addDaysIso(today, 2);
      const tomorrow = nextNonSunday(nominalTomorrow);
      const dayAfterTomorrow = nextNonSunday(nominalDayAfter <= tomorrow ? addDaysIso(today, 3) : nominalDayAfter);
      const firstBookable = nextNonSunday(minimum);
      const savedSunday = isSunday(dateInput.value);
      if (savedSunday) {
        window.louSundayDateWasCleared = true;
        dateInput.value = '';
        form.dataset.invalidSundayDate = 'true';
        clearSundayCartAttribute(form);
      } else if (!dateInput.value && window.louSundayDateWasCleared) {
        form.dataset.invalidSundayDate = 'true';
      }
      let visibleMonth = new Date((dateInput.value || tomorrow) + 'T12:00:00Z');

      dateInput.min = minimum;
      dateInput.max = maximum;
      form.dataset.minimumDate = minimum;
      form.dataset.maximumDate = maximum;
      tomorrowInput.value = tomorrow;
      dayAfterInput.value = dayAfterTomorrow;
      tomorrowInput.disabled = tomorrow > maximum;
      dayAfterInput.disabled = dayAfterTomorrow > maximum;
      if (tomorrow !== nominalTomorrow) {
        tomorrowInput.parentElement.querySelector('strong').textContent = formatDate(tomorrow, { weekday: 'long' });
      }
      if (dayAfterTomorrow !== nominalDayAfter) {
        dayAfterInput.parentElement.querySelector('strong').textContent = formatDate(dayAfterTomorrow, { weekday: 'long' });
      }
      form.querySelector('[data-date-tomorrow-label]').textContent = formatDate(tomorrow, { day: 'numeric', month: 'short' });
      form.querySelector('[data-date-day-after-label]').textContent = formatDate(dayAfterTomorrow, { day: 'numeric', month: 'short' });

      function validDate(iso) {
        return iso >= minimum && iso <= maximum && !isSunday(iso);
      }

      function updateDateState() {
        const selected = dateInput.value;
        const valid = validDate(selected);
        tomorrowInput.checked = selected === tomorrow;
        dayAfterInput.checked = selected === dayAfterTomorrow;
        const customSelected = valid && selected !== tomorrow && selected !== dayAfterTomorrow;
        customButton.setAttribute('aria-pressed', customSelected ? 'true' : 'false');
        dateSummary.hidden = !valid;
        dateSummaryValue.textContent = valid
          ? formatDate(selected, { weekday: 'long', day: 'numeric', month: 'long' })
          : '';
      }

      function selectDate(iso, closeCalendar) {
        if (form.dataset.deliveryAutomatic === 'true' && !parseOccupancy(form.dataset.deliveryOccupancy, true)) {
          updateSlotCapacity(form);
          return;
        }
        if (!validDate(iso)) return;
        dateInput.value = iso;
        visibleMonth = new Date(iso + 'T12:00:00Z');
        updateDateState();
        setInvalid(dateInput.closest('[data-delivery-field]'), false);
        dateInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (closeCalendar) {
          calendar.hidden = true;
          customButton.setAttribute('aria-expanded', 'false');
          customButton.focus();
        }
      }

      function isoFor(year, month, day) {
        return new Date(Date.UTC(year, month, day, 12)).toISOString().slice(0, 10);
      }

      function monthNumber(date) {
        return date.getUTCFullYear() * 12 + date.getUTCMonth();
      }

      function focusCalendarDate(iso) {
        if (!validDate(iso)) return;
        visibleMonth = new Date(iso + 'T12:00:00Z');
        renderCalendar();
        window.requestAnimationFrame(() => {
          calendar.querySelector('[data-calendar-date="' + iso + '"]')?.focus();
        });
      }

      function handleCalendarKey(event, iso) {
        const current = new Date(iso + 'T12:00:00Z');
        let offset = 0;
        if (event.key === 'ArrowLeft') offset = -1;
        if (event.key === 'ArrowRight') offset = 1;
        if (event.key === 'ArrowUp') offset = -7;
        if (event.key === 'ArrowDown') offset = 7;
        if (event.key === 'Home') offset = -((current.getUTCDay() + 6) % 7);
        if (event.key === 'End') offset = 6 - ((current.getUTCDay() + 6) % 7);
        if (!offset) return;
        event.preventDefault();
        const target = new Date(current);
        target.setUTCDate(target.getUTCDate() + offset);
        const direction = event.key === 'End' ? -1 : Math.sign(offset);
        while (isSunday(target.toISOString().slice(0, 10))) {
          target.setUTCDate(target.getUTCDate() + direction);
        }
        focusCalendarDate(target.toISOString().slice(0, 10));
      }

      function renderCalendar() {
        const year = visibleMonth.getUTCFullYear();
        const month = visibleMonth.getUTCMonth();
        const first = new Date(Date.UTC(year, month, 1, 12));
        const totalDays = new Date(Date.UTC(year, month + 1, 0, 12)).getUTCDate();
        const leadingDays = (first.getUTCDay() + 6) % 7;
        const minimumMonth = monthNumber(new Date(minimum + 'T12:00:00Z'));
        const maximumMonth = monthNumber(new Date(maximum + 'T12:00:00Z'));

        calendarHeading.textContent = formatDate(isoFor(year, month, 1), { month: 'long', year: 'numeric' });
        previousMonth.disabled = monthNumber(first) <= minimumMonth;
        nextMonth.disabled = monthNumber(first) >= maximumMonth;
        calendarDays.innerHTML = '';

        for (let index = 0; index < leadingDays; index += 1) {
          const spacer = document.createElement('span');
          spacer.setAttribute('aria-hidden', 'true');
          calendarDays.append(spacer);
        }

        for (let day = 1; day <= totalDays; day += 1) {
          const iso = isoFor(year, month, day);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cart-calendar__day';
          button.textContent = String(day);
          button.dataset.calendarDate = iso;
          button.disabled = !validDate(iso);
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          button.setAttribute('aria-label', formatDate(iso, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }));
          button.setAttribute('aria-pressed', dateInput.value === iso ? 'true' : 'false');
          button.tabIndex = dateInput.value === iso || (!dateInput.value && iso === firstBookable) ? 0 : -1;
          button.addEventListener('click', () => selectDate(iso, true));
          button.addEventListener('keydown', (event) => handleCalendarKey(event, iso));
          calendarDays.append(button);
        }
      }

      for (let index = 0; index < 7; index += 1) {
        const weekday = document.createElement('span');
        weekday.textContent = formatDate('2021-11-0' + (index + 1), { weekday: 'narrow' });
        calendarWeekdays.append(weekday);
      }

      tomorrowInput.addEventListener('change', () => {
        if (tomorrowInput.checked) selectDate(tomorrow, true);
      });
      dayAfterInput.addEventListener('change', () => {
        if (dayAfterInput.checked) selectDate(dayAfterTomorrow, true);
      });
      customButton.addEventListener('click', () => {
        const opening = calendar.hidden;
        calendar.hidden = !opening;
        customButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          visibleMonth = new Date((validDate(dateInput.value) ? dateInput.value : minimum) + 'T12:00:00Z');
          renderCalendar();
          window.requestAnimationFrame(() => {
            const preferred = calendar.querySelector('[aria-pressed="true"]')
              || calendar.querySelector('.cart-calendar__day:not(:disabled)');
            preferred?.focus();
          });
        }
      });
      previousMonth.addEventListener('click', () => {
        visibleMonth = new Date(Date.UTC(visibleMonth.getUTCFullYear(), visibleMonth.getUTCMonth() - 1, 1, 12));
        renderCalendar();
      });
      nextMonth.addEventListener('click', () => {
        visibleMonth = new Date(Date.UTC(visibleMonth.getUTCFullYear(), visibleMonth.getUTCMonth() + 1, 1, 12));
        renderCalendar();
      });
      dateInput.addEventListener('change', () => {
        if (form.dataset.deliveryAutomatic === 'true' && !parseOccupancy(form.dataset.deliveryOccupancy, true)) {
          updateSlotCapacity(form);
          return;
        }
        if (isSunday(dateInput.value)) {
          window.louSundayDateWasCleared = true;
          dateInput.value = '';
          form.dataset.invalidSundayDate = 'true';
          updateDateState();
          setInvalid(dateInput.closest('[data-delivery-field]'), true, 'sunday');
          updateSlotCapacity(form);
          clearSundayCartAttribute(form);
          return;
        }
        window.louSundayDateWasCleared = false;
        form.dataset.invalidSundayDate = 'false';
        updateDateState();
        form.dataset.fullSlotCleared = 'false';
        updateSlotCapacity(form);
        if (dateInput.value) setInvalid(dateInput.closest('[data-delivery-field]'), false);
      });

      if (form.dataset.clearGiftMessage === 'true' && !window.louGiftAttributeCleared) {
        window.louGiftAttributeCleared = true;
        fetch(form.dataset.cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Wiadomość na bileciku': '', 'Gift message': '' } }),
        }).catch(() => {
          window.louGiftAttributeCleared = false;
        });
      }

      form.classList.add('cart-delivery--enhanced');
      updateDateState();
      updateSlotCapacity(form);
      if (form.dataset.invalidSundayDate === 'true') setInvalid(dateInput.closest('[data-delivery-field]'), true, 'sunday');

      const customerContact = form.querySelector('[data-delivery-contact-customer]');
      const recipientPhoneLabel = form.querySelector('[data-phone-label-recipient]');
      const customerPhoneLabel = form.querySelector('[data-phone-label-customer]');
      function updatePhoneLabel() {
        const customerSelected = Boolean(customerContact?.checked);
        if (recipientPhoneLabel) recipientPhoneLabel.hidden = customerSelected;
        if (customerPhoneLabel) customerPhoneLabel.hidden = !customerSelected;
      }
      form.querySelectorAll('input[name="attributes[Kontakt w sprawie dostawy]"]').forEach((choice) => {
        choice.addEventListener('change', updatePhoneLabel);
      });
      updatePhoneLabel();

      const phone = form.querySelector('input[type="tel"]');
      phone?.addEventListener('blur', () => {
        const normalized = phone.value.trim().replace(/\s+/g, ' ');
        if (normalized !== phone.value) {
          phone.value = normalized;
          phone.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      form.addEventListener('input', (event) => {
        const field = event.target.closest('[data-delivery-field]');
        if (field && event.target.value.trim()) setInvalid(field, false);
      });
      form.addEventListener('change', (event) => {
        const field = event.target.closest('[data-delivery-field]');
        if (field && event.target.value) setInvalid(field, false);
        if (event.target.name === 'attributes[Przedział dostawy]') form.dataset.fullSlotCleared = 'false';
      });
    }
    function validateDeliveryForm(scope) {
      const form = scope.querySelector('[data-cart-delivery-form]');
      if (!form) return { valid: false, first: null };
      const date = form.querySelector('[data-delivery-date]');
      const slot = form.querySelector('input[name="attributes[Przedział dostawy]"]:checked');
      const counts = parseOccupancy(form.dataset.deliveryOccupancy, form.dataset.deliveryAutomatic === 'true');
      const slotFull = Boolean(slot && isSlotFull(counts, date.value, slot.value));
      const name = form.querySelector('input[name="attributes[Odbiorca]"]');
      const phone = form.querySelector('input[name="attributes[Telefon kontaktowy do dostawy]"]');
      const normalizedPhone = phone.value.replace(/[\s().-]/g, '');
      if (isSunday(date.value)) {
        window.louSundayDateWasCleared = true;
        date.value = '';
        form.dataset.invalidSundayDate = 'true';
        clearSundayCartAttribute(form);
      }
      const checks = [
        { field: date.closest('[data-delivery-field]'), valid: date.value >= form.dataset.minimumDate && date.value <= form.dataset.maximumDate && !isSunday(date.value), reason: form.dataset.invalidSundayDate === 'true' ? 'sunday' : null, focus: form.querySelector('.cart-delivery__date-shortcut input:not(:disabled)') },
        { field: form.querySelector('[data-delivery-field="slot"]'), valid: Boolean(counts && slot && !slot.disabled && !slotFull), reason: !counts ? 'config' : form.dataset.fullSlotCleared === 'true' || slotFull ? 'full' : null, focus: form.querySelector('.cart-delivery__slot input:not(:disabled)') || form.querySelector('[data-delivery-field="slot"]') },
        { field: name.closest('[data-delivery-field]'), valid: Boolean(name.value.trim()), focus: name },
        { field: phone.closest('[data-delivery-field]'), valid: /^\+?\d{7,15}$/.test(normalizedPhone), focus: phone },
      ];
      checks.forEach((check) => setInvalid(check.field, !check.valid, check.reason));
      const first = checks.find((check) => !check.valid);
      return { valid: !first, first: first?.focus || null };
    }

    function focusValidation(result) {
      if (!result.first) return;
      result.first.closest('[data-delivery-field]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => result.first.focus(), 250);
    }

    window.LouDelivery = { init: initDeliveryForm, validate: validateDeliveryForm, focusValidation, refreshCapacity: refreshSlotCapacity, updateCapacity: updateSlotCapacity, pendingSundayClear: () => window.louSundayDateClearPromise, pendingCapacityClear: () => window.louCapacitySlotClearPromise };
    function validateTerms(scope) {
      const checkbox = scope.querySelector('[data-terms-acceptance]');
      const error = scope.querySelector('[data-terms-error]');
      const valid = Boolean(checkbox?.checked);
      if (error) error.hidden = valid;
      if (checkbox) {
        if (valid) checkbox.removeAttribute('aria-invalid');
        else checkbox.setAttribute('aria-invalid', 'true');
      }
      return { valid, first: checkbox };
    }
    function focusTerms(result) {
      if (!result?.first) return;
      result.first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      result.first.focus();
    }
    window.LouTerms = { validate: validateTerms, focusValidation: focusTerms };
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-terms-acceptance]')) validateTerms(event.target.form);
    });
    document.querySelectorAll('[data-cart-delivery-form]').forEach(initDeliveryForm);

    function initDrawer(drawer) {
      if (drawer.dataset.cartInitialized) return;
      drawer.dataset.cartInitialized = 'true';

      const contentEl = drawer.querySelector('[data-cart-drawer-content]');
      const statusEl = drawer.querySelector('[data-cart-status]');
      const cartUrl = drawer.dataset.cartUrl;
      const sectionId = drawer.closest('.shopify-section')?.id.replace('shopify-section-', '');
      let lastFocused = null;
      let updateTimer = null;
      let mutationQueue = Promise.resolve();
      const controller = new AbortController();
      drawer.cartCleanup = () => {
        clearTimeout(updateTimer);
        controller.abort();
      };
      drawer.cartBeforeDiscount = () => mutationQueue.then(() => updateTimer ? saveAttributes(true) : undefined);

      function reportError(error) {
        console.error(error);
        if (statusEl) statusEl.textContent = drawer.dataset.cartError;
      }

      async function jsonRequest(url, body) {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Cart update failed');
        return result;
      }

      async function refreshCart() {
        if (window.louCapacitySlotClearPromise) await window.louCapacitySlotClearPromise;
        const sectionUrl = cartUrl + '?section_id=' + encodeURIComponent(sectionId || 'cart-drawer');
        const [cartResponse, sectionResponse] = await Promise.all([
          fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }),
          fetch(sectionUrl),
        ]);
        if (!cartResponse.ok || !sectionResponse.ok) throw new Error('Could not refresh cart');
        const cart = await cartResponse.json();
        const html = await sectionResponse.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-drawer-content]');
        if (!newContent) throw new Error('Could not refresh cart drawer');
        contentEl.innerHTML = newContent.innerHTML;
        contentEl.querySelectorAll('[data-cart-delivery-form]').forEach((form) => window.LouDelivery?.init(form));
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
          el.textContent = el.dataset.cartLabelTemplate.replace('__COUNT__', cart.item_count);
        });
        return cart;
      }

      function mutate(url, body, focusName, refresh = true, propagateError = false) {
        const operation = mutationQueue.catch(() => {}).then(async () => {
          contentEl.setAttribute('aria-busy', 'true');
          if (statusEl) statusEl.textContent = '';
          try {
            if (window.louSundayDateClearPromise) await window.louSundayDateClearPromise;
            if (window.louCapacitySlotClearPromise) await window.louCapacitySlotClearPromise;
            await jsonRequest(url, body);
            if (refresh) {
              await refreshCart();
              const restoredField = focusName
                ? Array.from(contentEl.querySelectorAll('[data-cart-attribute]')).find((field) => field.name === focusName)
                : null;
              (restoredField || drawer.querySelector('[data-cart-close]'))?.focus();
            }
          } catch (error) {
            if (propagateError) throw error;
            reportError(error);
          } finally {
            contentEl.removeAttribute('aria-busy');
          }
        });
        mutationQueue = operation.catch(() => {});
        return operation;
      }

      function collectAttributes() {
        const attributes = {
          'Wiadomość na bileciku': '',
          'Gift message': '',
          'Przedział dostawy': '',
        };
        contentEl.querySelectorAll('[data-cart-attribute]').forEach((field) => {
          const match = field.name.match(/^attributes\[(.+)\]$/);
          if (!match) return;
          if (field.type === 'radio' && !field.checked) return;
          attributes[match[1]] = field.value;
        });
        return attributes;
      }

      function saveAttributes(requireSuccess = false) {
        if (updateTimer) clearTimeout(updateTimer);
        updateTimer = null;
        return mutate(drawer.dataset.cartUpdateUrl, { attributes: collectAttributes() }, null, false, requireSuccess);
      }

      function scheduleAttributeSave() {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(() => {
          updateTimer = null;
          saveAttributes();
        }, 500);
      }

      function openDrawer(trigger) {
        if (drawer.open) return;
        lastFocused = trigger || document.activeElement;
        drawer.showModal();
        drawer.querySelector('[data-cart-close]')?.focus();
      }

      drawer.addEventListener('close', () => {
        if (updateTimer) saveAttributes();
        if (lastFocused?.isConnected) lastFocused.focus();
        lastFocused = null;
      });
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer || event.target.closest('[data-cart-close]')) drawer.close();
      });
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cart-toggle]');
        if (!trigger) return;
        event.preventDefault();
        mutationQueue.then(refreshCart).then(() => openDrawer(trigger)).catch((error) => {
          reportError(error);
          openDrawer(trigger);
        });
      }, { signal: controller.signal });
      document.addEventListener('cart:add', () => {
        refreshCart().then(() => openDrawer()).catch(reportError);
      }, { signal: controller.signal });

      contentEl.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
        const remove = event.target.closest('[data-remove-line]');
        if (remove) {
          event.preventDefault();
          const pendingSave = updateTimer ? saveAttributes() : Promise.resolve();
          pendingSave.then(() => mutate(drawer.dataset.cartChangeUrl, { id: remove.dataset.lineKey, quantity: 0 }));
        } else if (button) {
          const wrapper = button.closest('[data-line-key]');
          const input = wrapper?.querySelector('[data-quantity-input]');
          if (!input) return;
          const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
          const quantity = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          input.value = quantity;
          const pendingSave = updateTimer ? saveAttributes() : Promise.resolve();
          pendingSave.then(() => mutate(drawer.dataset.cartChangeUrl, { id: wrapper.dataset.lineKey, quantity }));
        }
      });

      contentEl.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-quantity-input]')) {
          const wrapper = input.closest('[data-line-key]');
          if (wrapper) {
            const pendingSave = updateTimer ? saveAttributes() : Promise.resolve();
            pendingSave.then(() => mutate(drawer.dataset.cartChangeUrl, {
              id: wrapper.dataset.lineKey,
              quantity: Math.max(0, parseInt(input.value, 10) || 0),
            }));
          }
        } else if (input.matches('[data-cart-attribute]')) {
          scheduleAttributeSave();
        }
      });

      contentEl.addEventListener('input', (event) => {
        if (event.target.matches('[data-cart-attribute]')) scheduleAttributeSave();
      });

      contentEl.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-cart-checkout-form]');
        if (!form || event.submitter?.name !== 'checkout' || form.dataset.checkoutReady === 'true') return;
        event.preventDefault();
        if (form.dataset.capacityChecking === 'true') return;
        const submitter = event.submitter;
        form.dataset.capacityChecking = 'true';
        submitter.disabled = true;
        window.LouDelivery.refreshCapacity(form).then(() => {
          const result = window.LouDelivery?.validate(form);
          const terms = window.LouTerms?.validate(form);
          if (!result?.valid || !terms?.valid) {
            if (!result?.valid) window.LouDelivery?.focusValidation(result);
            else window.LouTerms?.focusValidation(terms);
            return;
          }
          return saveAttributes(true).then(() => {
            form.dataset.checkoutReady = 'true';
            submitter.disabled = false;
            form.requestSubmit(submitter);
          });
        }).catch(reportError).finally(() => {
          form.dataset.capacityChecking = 'false';
          submitter.disabled = false;
        });
      });
    }

    document.querySelectorAll('[data-cart-drawer]').forEach(initDrawer);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cart-delivery-form]').forEach(initDeliveryForm);
      event.target.querySelectorAll('[data-cart-drawer]').forEach(initDrawer);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-cart-drawer]').forEach((drawer) => drawer.cartCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initCartPage(page) {
    if (page.dataset.cartPageInitialized) return;
    page.dataset.cartPageInitialized = 'true';
    page.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!button) return;
      const wrapper = button.closest('.quantity-selector');
      const input = wrapper ? wrapper.querySelector('[data-quantity-input]') : null;
      if (!input) return;
      const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    });
    page.querySelector('[data-cart-checkout-form]')?.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;
      const form = event.currentTarget;
      if (form.dataset.checkoutReady === 'true') return;
      event.preventDefault();
      if (form.dataset.capacityChecking === 'true') return;
      const submitter = event.submitter;
      form.dataset.capacityChecking = 'true';
      submitter.disabled = true;
      window.LouDelivery.refreshCapacity(form).then(async () => {
        const result = window.LouDelivery.validate(form);
        const terms = window.LouTerms.validate(form);
        if (!result.valid || !terms.valid) {
          if (!result.valid) window.LouDelivery.focusValidation(result);
          else window.LouTerms.focusValidation(terms);
          return;
        }
        const pending = [window.LouDelivery.pendingSundayClear(), window.LouDelivery.pendingCapacityClear()].filter(Boolean);
        if (pending.length) await Promise.all(pending);
        form.dataset.checkoutReady = 'true';
        submitter.disabled = false;
        form.requestSubmit(submitter);
      }).catch((error) => {
        console.error(error);
        const deliveryForm = form.querySelector('[data-cart-delivery-form]');
        if (deliveryForm) {
          deliveryForm.dataset.deliveryOccupancy = '';
          window.LouDelivery.updateCapacity(deliveryForm);
          window.LouDelivery.validate(form);
        }
      }).finally(() => {
        form.dataset.capacityChecking = 'false';
        submitter.disabled = false;
      });
    });
  }

  document.querySelectorAll('.cart-page').forEach(initCartPage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.cart-page').forEach(initCartPage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initCollectionSort(form) {
    if (form.dataset.sortInitialized) return;
    form.dataset.sortInitialized = 'true';
    form.querySelector('[data-collection-sort]')?.addEventListener('change', () => form.requestSubmit());
  }

  document.querySelectorAll('[data-collection-sort-form]').forEach(initCollectionSort);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-collection-sort-form]').forEach(initCollectionSort);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initLouHeader(header) {
    if (header.dataset.headerInitialized) return;
    header.dataset.headerInitialized = 'true';
    const dialog = header.closest('.shopify-section').querySelector('[data-menu-dialog]');
    const opener = header.querySelector('[data-menu-open]');
    const desktop = window.matchMedia('(min-width: 750px)');
    const dropdowns = Array.from(header.querySelectorAll('[data-nav-dropdown]'));
    let returnFocus = true;
    const setDropdown = (dropdown, expanded) => {
      if (expanded) {
        Array.from(dropdown.parentElement.children).forEach((sibling) => {
          if (sibling !== dropdown && sibling.matches('[data-nav-dropdown]')) setDropdown(sibling, false);
        });
      }
      dropdown.classList.toggle('is-open', expanded);
      dropdown.querySelector(':scope > [data-nav-dropdown-trigger]')?.setAttribute('aria-expanded', String(expanded));
    };

    dropdowns.forEach((dropdown) => {
      const trigger = dropdown.querySelector(':scope > [data-nav-dropdown-trigger]');
      const menu = dropdown.querySelector(':scope > [data-nav-dropdown-menu]');
      if (!trigger || !menu) return;

      dropdown.addEventListener('pointerenter', () => {
        if (desktop.matches) setDropdown(dropdown, true);
      });
      dropdown.addEventListener('pointerleave', () => {
        if (desktop.matches && !dropdown.contains(document.activeElement)) setDropdown(dropdown, false);
      });
      dropdown.addEventListener('focusin', () => setDropdown(dropdown, true));
      dropdown.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!dropdown.contains(document.activeElement)) setDropdown(dropdown, false);
        }, 0);
      });
      dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (!dropdown.classList.contains('is-open')) return;
          event.preventDefault();
          event.stopPropagation();
          trigger.focus({ preventScroll: true });
          setDropdown(dropdown, false);
        }
        if (event.key === 'ArrowDown' && event.target === trigger) {
          event.preventDefault();
          setDropdown(dropdown, true);
          menu.querySelector('a')?.focus();
        }
      });
    });
    opener.addEventListener('click', () => {
      returnFocus = true;
      dialog.showModal();
      dialog.querySelector('[data-menu-close]').focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('a')) returnFocus = false;
      if (event.target === dialog || event.target.closest('[data-menu-close], a')) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (returnFocus && !desktop.matches && opener.isConnected) opener.focus({ preventScroll: true });
    });
    const onResize = () => {
      if (desktop.matches && dialog.open) dialog.close();
      if (!desktop.matches) dropdowns.forEach((dropdown) => setDropdown(dropdown, false));
    };
    desktop.addEventListener('change', onResize);
    header.cleanupHeader = () => {
      desktop.removeEventListener('change', onResize);
      if (dialog.open) dialog.close();
    };
  }
  document.querySelectorAll('[data-header]').forEach(initLouHeader);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-header]').forEach(initLouHeader));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-header]').forEach((header) => header.cleanupHeader?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initLouHero(hero) {
    const cta = hero.querySelector('.hero__cta[href^="#"], .hero__editorial-cta[href^="#"]');
    if (cta && !hero.dataset.scrollInitialized) {
      hero.dataset.scrollInitialized = 'true';
      cta.addEventListener('click', (event) => {
        const target = document.getElementById(cta.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        history.pushState(null, '', cta.hash);
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    const video = hero.querySelector('.hero__video');
    if (!video || hero.dataset.videoInitialized) return;
    hero.dataset.videoInitialized = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    let frameHandle;
    let sourceVersion = 0;
    const showPoster = () => video.classList.remove('is-playing');
    const showVideo = () => {
      if (video.paused || reducedMotion.matches) return;
      const version = sourceVersion;
      if (video.requestVideoFrameCallback) {
        if (frameHandle != null) video.cancelVideoFrameCallback(frameHandle);
        frameHandle = video.requestVideoFrameCallback(() => {
          if (version === sourceVersion && !video.paused && !reducedMotion.matches) video.classList.add('is-playing');
        });
      } else {
        video.classList.add('is-playing');
      }
    };
    video.addEventListener('playing', showVideo);
    video.addEventListener('error', showPoster);
    video.addEventListener('emptied', showPoster);
    video.controls = false;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const selectSource = () => {
      const poster = mobile.matches ? (video.dataset.mobilePoster || video.dataset.desktopPoster) : video.dataset.desktopPoster;
      if (poster) video.poster = poster;
      if (reducedMotion.matches) return;
      if (!video.dataset.desktopSrc) {
        video.play().catch(showPoster);
        return;
      }
      const src = mobile.matches ? (video.dataset.mobileSrc || video.dataset.desktopSrc) : video.dataset.desktopSrc;
      if (!src || video.dataset.activeSrc === src) return;
      sourceVersion += 1;
      if (frameHandle != null && video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frameHandle);
      video.pause();
      showPoster();
      video.dataset.activeSrc = src;
      video.src = src;
      video.load();
      video.play().catch(showPoster);
    };
    const onMotionChange = () => {
      if (reducedMotion.matches) {
        video.pause();
        showPoster();
      }
      else {
        selectSource();
        if (video.dataset.activeSrc && video.paused) video.play().catch(showPoster);
      }
    };
    reducedMotion.addEventListener('change', onMotionChange);
    mobile.addEventListener('change', selectSource);
    selectSource();
    hero.cleanupHero = () => {
      video.pause();
      reducedMotion.removeEventListener('change', onMotionChange);
      mobile.removeEventListener('change', selectSource);
      video.removeEventListener('playing', showVideo);
      video.removeEventListener('error', showPoster);
      video.removeEventListener('emptied', showPoster);
      if (frameHandle != null && video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frameHandle);
    };
  }
  document.querySelectorAll('.hero').forEach(initLouHero);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.hero').forEach(initLouHero));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('.hero').forEach((hero) => hero.cleanupHero?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limited-collection"] && !Shopify.designMode) return;
  try {
    
  function initLouLimited(section) {
    if (section.cleanupLimited) return;
    const header = document.querySelector('[data-header][data-sticky]');
    const updateOffset = () => section.style.setProperty('--limited-anchor-offset', `${(header?.getBoundingClientRect().height || 0) + 20}px`);
    const observer = new ResizeObserver(updateOffset);
    if (header) observer.observe(header);
    updateOffset();
    section.cleanupLimited = () => observer.disconnect();
  }
  document.querySelectorAll('.limited-collection').forEach(initLouLimited);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.limited-collection').forEach(initLouLimited));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.limited-collection').forEach(section => section.cleanupLimited?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initProduct(form) {
    if (form.dataset.productInitialized) return;
    form.dataset.productInitialized = 'true';
    const productRoot = form.closest('.shopify-section') || document;
    const variantsScript = productRoot.querySelector('[data-product-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const picker = productRoot.querySelector('[data-variant-picker]');
    const variantIdInput = form.querySelector('[data-product-variant-id]');
    const priceEls = productRoot.querySelectorAll('[data-product-price], [data-product-price-sticky]');
    const availabilityEl = productRoot.querySelector('[data-product-availability]');
    const addButtons = productRoot.querySelectorAll('[data-add-to-cart], [data-sticky-add-to-cart]');
    const mediaGallery = productRoot.querySelector('[data-media-gallery]');
    const variantDetails = productRoot.querySelector('[data-variant-details]');
    const labelInStock = form.dataset.labelInStock;
    const labelSoldOut = form.dataset.labelSoldOut;
    const labelAddToCart = form.dataset.labelAddToCart;
    const cartAddUrl = form.dataset.cartAddUrl;
    const quantityInput = form.querySelector('[data-quantity-input]');
    const decreaseButton = form.querySelector('[data-quantity-decrease]');
    const temporaryUnavailableOption = form.dataset.temporaryUnavailableOption;
    const labelTemporaryUnavailable = form.dataset.labelTemporaryUnavailable;

    function setQuantity(value) {
      if (!quantityInput) return;
      const quantity = Math.max(1, Math.floor(Number(value) || 1));
      quantityInput.value = String(quantity);
      if (decreaseButton) decreaseButton.disabled = quantity === 1;
    }

    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (!button || !quantityInput) return;
      const delta = button.hasAttribute('data-quantity-increase') ? 1 : -1;
      setQuantity((Number(quantityInput.value) || 1) + delta);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    quantityInput?.addEventListener('change', () => setQuantity(quantityInput.value));
    setQuantity(quantityInput?.value);

    function updateVariantDetails(variant) {
      if (!variantDetails) return;
      let hasDetails = false;
      variantDetails.querySelectorAll('[data-variant-detail]').forEach((row) => {
        let value = variant.details?.[row.dataset.variantDetail];
        if (row.dataset.variantDetail === 'size_label' && variant.details?.flower_count) value = null;
        row.hidden = value === null || value === undefined || value === '';
        if (!row.hidden) {
          row.querySelector('[data-variant-detail-value]').textContent = value;
          hasDetails = true;
        }
      });
      variantDetails.hidden = !hasDetails;
    }

    function findVariant() {
      if (!picker) return variants[0];
      const selected = {};
      picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        selected[input.dataset.optionPosition] = input.value;
      });
      return variants.find((variant) =>
        Object.keys(selected).every((position) => variant.options[position - 1] === selected[position])
      );
    }

    function updateAvailableOptions() {
      if (!picker) return;
      const groups = picker.querySelectorAll('.variant-picker__option');
      groups.forEach((group) => {
        const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
        const position = radios[0] ? radios[0].dataset.optionPosition : null;
        if (!position) return;

        const otherSelections = {};
        picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          if (input.dataset.optionPosition !== position) {
            otherSelections[input.dataset.optionPosition] = input.value;
          }
        });

        radios.forEach((radio) => {
          const wouldMatch = variants.some((variant) => {
            if (variant.options[position - 1] !== radio.value) return false;
            return Object.keys(otherSelections).every(
              (pos) => variant.options[pos - 1] === otherSelections[pos]
            );
          });
          radio.disabled = !wouldMatch;
        });
      });
    }

    function selectVariant(variant) {
      if (!variant || !picker) return;
      picker.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = variant.options[Number(radio.dataset.optionPosition) - 1] === radio.value;
      });
    }

    function variantFromURL() {
      const id = new URL(window.location.href).searchParams.get('variant');
      return variants.find((variant) => String(variant.id) === id);
    }

    const initialVariant = variants.find((variant) => String(variant.id) === variantIdInput?.value);

    function updateUI(event, historyMode = 'none') {
      let variant = findVariant();
      if (!variant && event?.target?.matches('input[type="radio"]')) {
        const changed = event.target;
        variant = variants.find((item) => item.options[changed.dataset.optionPosition - 1] === changed.value);
        selectVariant(variant);
      }
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      priceEls.forEach((el) => {
        el.textContent = variant.price_formatted || el.textContent;
      });

      const unavailableLabel = temporaryUnavailableOption === variant.options[0] && !variant.available
        ? labelTemporaryUnavailable : labelSoldOut;
      if (availabilityEl) availabilityEl.textContent = variant.available ? labelInStock : unavailableLabel;

      addButtons.forEach((button) => {
        button.disabled = !variant.available;
        const label = button.querySelector('[data-add-to-cart-text]');
        if (label) {
          label.textContent = variant.available ? labelAddToCart : unavailableLabel;
        }
      });

      if (mediaGallery) {
        const mediaId = variant.featured_media_id || mediaGallery.dataset.defaultMediaId;
        mediaGallery.dispatchEvent(
          new CustomEvent('variant:change', { detail: { featured_media_id: mediaId, variant_id: variant.id, variant_option1: variant.options[0] } })
        );
      }

      updateVariantDetails(variant);

      if (historyMode === 'push') {
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== String(variant.id)) {
          url.searchParams.set('variant', variant.id);
          window.history.pushState({}, '', url);
        }
      }

      updateAvailableOptions();
    }

    if (picker) {
      picker.addEventListener('change', (event) => updateUI(event, 'push'));
      updateAvailableOptions();
    }

    form.productPopstateHandler = () => {
      selectVariant(variantFromURL() || initialVariant);
      updateUI();
    };
    window.addEventListener('popstate', form.productPopstateHandler);
    if (variantFromURL()) selectVariant(variantFromURL());
    updateUI();

    form.addEventListener('submit', (event) => {
      if (typeof window.fetch !== 'function') return;
      event.preventDefault();

      setQuantity(quantityInput?.value);
      const submitButton = form.querySelector('[data-add-to-cart]');
      if (submitButton) submitButton.disabled = true;

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok || data.status) {
            const message = data.description || data.message;
            if (message) window.alert(message);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:add', { detail: data }));
        })
        .catch(() => {
          window.alert(form.dataset.cartError);
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = !findVariant()?.available;
        });
    });

    const stickyButton = productRoot.querySelector('[data-sticky-add-to-cart]');
    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    const stickyBar = productRoot.querySelector('[data-sticky-bar]');
    const mainButton = form.querySelector('[data-add-to-cart]');
    if (stickyBar && mainButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
          });
        },
        { threshold: 0 }
      );
      observer.observe(mainButton);
      form.productObserver = observer;
    }
  }

  document.querySelectorAll('[data-product-form]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-form]').forEach(initProduct);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-product-form]').forEach((form) => {
      form.productObserver?.disconnect();
      window.removeEventListener('popstate', form.productPopstateHandler);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  function initWishlistPage(root) {
    if (root.dataset.wishlistPageInitialized) return;
    root.dataset.wishlistPageInitialized = 'true';
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const template = root.querySelector('[data-wishlist-card-template]');
    const controller = new AbortController();
    let renderVersion = 0;

    function productUrl(handle) {
      const shopRoot = window.Shopify?.routes?.root || '/';
      return `${shopRoot}products/${encodeURIComponent(handle)}`;
    }

    function formatPrice(price) {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {
        style: 'currency',
        currency: root.dataset.currency || 'PLN',
        maximumFractionDigits: 0,
      }).format(Number(price) / 100);
    }

    function buildCard(product) {
      const fragment = template.content.cloneNode(true);
      const url = productUrl(product.handle);
      const links = fragment.querySelectorAll('[data-wishlist-product-link], [data-wishlist-product-title]');
      const title = fragment.querySelector('[data-wishlist-product-title]');
      const image = fragment.querySelector('[data-wishlist-product-image]');
      const placeholder = fragment.querySelector('[data-wishlist-product-placeholder]');
      const price = fragment.querySelector('[data-wishlist-product-price]');
      const button = fragment.querySelector('[data-wishlist-toggle]');
      const label = root.dataset.removeLabelTemplate.replace('__PRODUCT__', product.title);

      links.forEach((link) => { link.href = url; });
      title.textContent = product.title;
      price.textContent = formatPrice(product.price);
      button.dataset.productHandle = product.handle;
      button.dataset.addLabel = root.dataset.addLabelTemplate.replace('__PRODUCT__', product.title);
      button.dataset.removeLabel = label;
      button.setAttribute('aria-label', label);
      button.querySelector('[data-wishlist-label]').textContent = label;

      if (product.featured_image) {
        image.src = product.featured_image;
        image.alt = product.title;
        image.hidden = false;
        placeholder.hidden = true;
      }

      return fragment;
    }

    async function render() {
      if (!window.LouWishlist) return;
      const currentVersion = ++renderVersion;
      const handles = window.LouWishlist.getHandles();
      root.setAttribute('aria-busy', 'true');

      if (handles.length === 0) {
        grid.replaceChildren();
        empty.hidden = false;
        root.removeAttribute('aria-busy');
        return;
      }

      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`${productUrl(handle)}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.ok ? response.json() : null)
            .catch(() => null)
        )
      );

      if (currentVersion !== renderVersion) return;
      grid.replaceChildren();
      products.filter(Boolean).forEach((product) => grid.append(buildCard(product)));
      empty.hidden = grid.children.length > 0;
      window.LouWishlist.sync(root);
      root.removeAttribute('aria-busy');
    }

    document.addEventListener('lou:wishlist:change', render, { signal: controller.signal });
    document.addEventListener('lou:wishlist:ready', render, { signal: controller.signal });
    root.wishlistController = controller;

    if (window.LouWishlist) render();
  }

  document.querySelectorAll('[data-wishlist-page]').forEach(initWishlistPage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-wishlist-page]').forEach(initWishlistPage);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-wishlist-page]').forEach((root) => root.wishlistController?.abort());
  });

  } catch(e) { console.error(e); }
})();
})();
